import { TypeStatusDaViagem } from "../../../Models/Domain/Viagem/StatusDaViagem";
import { useQuery } from "@tanstack/react-query";
import { Axios } from "../../Axios";

export class StatusDaViagemService {

    public listarStatusDisponiveis(){
        return Axios.get<TypeStatusDaViagem[]>(`quiron/viagem/status/disponiveis`);
    }

}

const useGetPossiveisStatusDaViagem = () => {
    return useQuery({
        queryKey: ["status-da-viagem"],
        queryFn: () => Axios.get<TypeStatusDaViagem[]>(`quiron/viagem/status/disponiveis`),
        staleTime: 1000 * 60 * 1 // query ficará valida por 1 min
    });
}

export const StatusDaViagemServiceH = {
    useGetPossiveisStatusDaViagem: useGetPossiveisStatusDaViagem
}

export default StatusDaViagemService;